module.exports = function getResource(label) {
    let resources = {
        pickupNotOffered: ' –Le ramassage n’est pas offert',
        openUntil: 'Ouvert jusqu’à ',
        closed: 'Fermé',
        milesAway: ' kilomètres de distance',
        inStock: 'En stock',
        outOfStock: 'Rupture de stock',
        limitedStock: 'Quantités limitées',
        payInStore: 'Payer en magasin',
        payOnline: 'Payer en ligne'
    };

    return resources[label];
};
